import LocationInfo from "./LocationInfo"
class DimensionInfo
{
    readonly id: string;
    name: string;
    description?: string;
    rating: number;
    locations?: LocationInfo[];
    region?: {
        point: {
            lat: number;
            lng: number;
        },
        radius: number;
    }

    constructor(data: any) {
        if (!data) {
            throw "Null data for DimensionInfo";
        }
        this.id = data.id;
        this.name = data.name ? data.name : this.id;
        this.description = data.description
        this.rating = 3;
        if (data.locations) {
            this.locations = [];
            for (const [id, locInfo] of Object.entries(data.locations)) {
                this.locations.push(new LocationInfo(locInfo));
            }
        }
        this.region = data.region;
    }

}

export default DimensionInfo;
